export default __webpack_public_path__ + "static/gabe-2e61bf69b663afeb8ab261e67a67b89a.jpg";